// Compact pager: ‹ 1 2 … N ›. Renders nothing when there's <=1 page.
// Stateless — page state lives in the parent.
export default function Pagination({ page, totalPages, onChange }) {
  if (totalPages <= 1) return null

  const pages = pageWindow(page, totalPages)

  return (
    <nav aria-label="Pagination" className="flex items-center justify-center gap-1 mt-3 text-xs">
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        className="px-2 py-1 rounded hover:bg-[color:var(--color-cloud)] dark:hover:bg-coal disabled:opacity-30 disabled:hover:bg-transparent transition"
        aria-label="Previous page"
      >
        ‹
      </button>
      {pages.map((p, i) =>
        p === "…" ? (
          <span key={`gap-${i}`} className="px-2 py-1 text-[color:var(--color-muted)] dark:text-muted-light">
            …
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={
              "px-2 py-1 rounded transition " +
              (p === page
                ? "bg-voltage text-coal font-semibold"
                : "hover:bg-[color:var(--color-cloud)] dark:hover:bg-coal text-ink dark:text-cloud")
            }
            aria-current={p === page ? "page" : undefined}
          >
            {p}
          </button>
        )
      )}
      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        className="px-2 py-1 rounded hover:bg-[color:var(--color-cloud)] dark:hover:bg-coal disabled:opacity-30 disabled:hover:bg-transparent transition"
        aria-label="Next page"
      >
        ›
      </button>
    </nav>
  )
}

// Builds the window of page numbers to show. Always shows 1, the current
// page and its neighbours, and the last page. Inserts "…" for elided gaps.
// Examples:
//   pageWindow(1, 5)  → [1, 2, 3, 4, 5]
//   pageWindow(7, 10) → [1, "…", 6, 7, 8, "…", 10]
//   pageWindow(1, 10) → [1, 2, 3, "…", 10]
function pageWindow(page, totalPages) {
  if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1)

  const pages = new Set([1, totalPages, page, page - 1, page + 1])
  const filtered = [...pages]
    .filter((p) => p >= 1 && p <= totalPages)
    .sort((a, b) => a - b)

  const out = []
  for (let i = 0; i < filtered.length; i++) {
    out.push(filtered[i])
    if (i + 1 < filtered.length && filtered[i + 1] !== filtered[i] + 1) {
      out.push("…")
    }
  }
  return out
}
